import { fromJS } from 'immutable';
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';

// init data
const defaultState = fromJS({
    matters: []
});

// action key
const SET_MATTERS = 'matter/SET_MATTERS';
const GET_MATTERS = 'matter/GET_MATTERS';
// action
export const setMatters = (value) => ({ type: SET_MATTERS, value });
export const getMatters = (case_id, params) => {
    return (dispath) => {
        //异步action
        instance.get(BASE_URL + 'admin/cases/' + case_id + '/matters', { params }).then((res) => {
            if(res.data.data){
                const value = fromJS(res.data.data)
                dispath({ type: GET_MATTERS, value })
            }else{
                const value = fromJS([])
                dispath({ type: GET_MATTERS, value })
            }
            console.log(res)
        })
    }
};

// reducer
export const reducer = (state = defaultState, action) => {
    if (action.type === SET_MATTERS) {
        return state.set('matters', action.value);
    } else if (action.type === GET_MATTERS) {
        return state.set('matters', action.value);
    }
    return state;
}